export function normalizePlantIdForModal (plantId: string): string {
    if (plantId.includes('BSAD')) {
        return plantId.split(' [BSAD]')[0];
    }
    return plantId;
}
